export default theme => ({
    imageLinkRow: {
        position: 'relative',
        marginBottom: 36,
    },
    imageLinkRowTheme: {
        ...theme.imageLinkRowTheme
    },
})